import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const BrandContext = createContext(null)

export function BrandProvider({ children }) {
  const [selectedBrand, setSelectedBrandState] = useState(() => {
    try {
      const stored = localStorage.getItem('selectedBrand')
      return stored ? JSON.parse(stored) : null
    } catch {
      return null
    }
  })
  const [account, setAccount] = useState(() => {
    try {
      const stored = localStorage.getItem('adminAccount')
      return stored ? JSON.parse(stored) : null
    } catch {
      return null
    }
  })

  const [onizleme, setOnizlemeState] = useState(() => {
    try {
      const stored = localStorage.getItem('onizlemeMarka')
      return stored ? JSON.parse(stored) : null
    } catch {
      return null
    }
  })

  function setSelectedBrand(brand) {
    setSelectedBrandState(brand)
    try {
      if (brand) localStorage.setItem('selectedBrand', JSON.stringify(brand))
      else localStorage.removeItem('selectedBrand')
    } catch {}
  }

  useEffect(() => {
    if (account?.role !== 'brand_admin' || !account?.brand_id) return
    const token = localStorage.getItem('adminToken')
    if (!token) return
    axios.get(`${API}/admin/brands/${account.brand_id}`, { headers: { Authorization: token } })
      .then(res => {
        const marka = res.data
        if (!marka) return
        setSelectedBrand(marka)
        const yeni = Array.isArray(marka.enabled_features) ? marka.enabled_features : null
        const eski = Array.isArray(account.enabled_features) ? account.enabled_features : null
        if (JSON.stringify(yeni) !== JSON.stringify(eski)) {
          const guncel = { ...account, enabled_features: yeni }
          setAccount(guncel)
          try { localStorage.setItem('adminAccount', JSON.stringify(guncel)) } catch {}
        }
      })
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.role, account?.brand_id])

  // Süper admin, seçtiği markanın gözünden paneli görüntüler (yalnız arayüz simülasyonu)
  function setOnizleme(brand) {
    setOnizlemeState(brand)
    try {
      if (brand) localStorage.setItem('onizlemeMarka', JSON.stringify(brand))
      else localStorage.removeItem('onizlemeMarka')
    } catch {}
    if (brand) setSelectedBrand(brand)
  }

  function saveAccount(acc) {
    setAccount(acc)
    localStorage.setItem('adminAccount', JSON.stringify(acc))
  }

  function clearAccount() {
    setAccount(null)
    localStorage.removeItem('adminAccount')
    setSelectedBrand(null)
    setOnizleme(null)
  }

  // Önizleme açıkken menü/rota koruması marka kullanıcısıymış gibi davranır
  const etkinHesap = (account?.role === 'super_admin' && onizleme)
    ? {
        ...account,
        role: 'brand_admin',
        brand_id: onizleme.id,
        enabled_features: Array.isArray(onizleme.enabled_features) ? onizleme.enabled_features : null,
      }
    : account

  return (
    <BrandContext.Provider value={{
      selectedBrand, setSelectedBrand,
      account: etkinHesap, gercekHesap: account,
      onizleme, setOnizleme,
      saveAccount, clearAccount,
    }}>
      {children}
    </BrandContext.Provider>
  )
}

export function useBrand() {
  return useContext(BrandContext)
}
